export default __webpack_public_path__ + "static/artifakt-element-medium-34ea105dcfa9b5b9275d6bbc9dd850da.svg";